import { Ref } from 'react'

interface AutoCatIconProps {
  sparkleOneRef?: Ref<SVGGElement>
  sparkleTwoRef?: Ref<SVGGElement>
  className?: string
}

export const AutoCatIcon = ({
  sparkleOneRef,
  sparkleTwoRef,
  className,
}: AutoCatIconProps) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Notepad, stays still */}
    <g>
      <g>
        <path
          d="M5.04688 10.383L9.67775 5.28906H59.9228V67.8059L55.5234 72.8998H5.04688V10.383Z"
          fill="#ABE0C7"
        />
        <path
          d="M5.04688 72.8998H55.5234L59.9228 67.8059V5.28906H9.67775L5.04688 10.383V72.8998ZM5.04688 72.8998L9.67775 67.8059"
          stroke="#1D1D1D"
          strokeWidth="0.3"
        />
      </g>
      <g>
        <mask
          id="autoCatMask0"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="9"
          y="5"
          width="51"
          height="63"
        >
          <path
            d="M9.67969 5.28906H59.6931V67.8059H9.67969V5.28906Z"
            fill="white"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
        </mask>
        <g mask="url(#autoCatMask0)">
          <path
            d="M9.67969 5.28906H60.1562V67.8059H9.67969V5.28906Z"
            fill="white"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <g style={{ mixBlendMode: 'multiply' }}>
            <path
              d="M9.67969 5.28906H59.6931V62.7119H9.67969V5.28906Z"
              fill="#90B3A8"
            />
          </g>
        </g>
      </g>
      <path
        d="M9.69322 5.28906C9.6596 7.14336 9.69322 9.08806 9.69322 11.1493V11.4081C9.69322 14.6791 9.69322 18.2039 9.69322 21.7512C9.69322 23.5518 9.65838 25.421 9.69322 27.2375C10.1335 50.1895 14.7872 55.9918 17.4029 63.175H68.9529C66.4133 51.3731 59.9387 40.73 59.9387 16.2997C59.9001 14.8779 59.9387 13.4298 59.9387 11.9646C59.9387 9.57424 59.9574 7.37235 59.9505 5.28906H9.69322Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path
        d="M13.8586 8.53125C13.8305 10.1185 13.8586 11.7832 13.8586 13.5476V13.7691C13.8586 16.5691 13.8586 19.5863 13.8586 22.6228C13.8586 24.1641 13.8295 25.7642 13.8586 27.3191C14.2267 46.966 18.58 51.9328 20.7665 58.0816H63.8592C61.7362 47.9792 56.3238 38.8687 56.3238 17.9563C56.2916 16.7393 56.3238 15.4997 56.3238 14.2455C56.3238 12.1994 56.3395 10.3145 56.3336 8.53125H13.8586Z"
        fill="#FCF1D4"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <g>
        <path
          d="M13.8606 8.53125C13.8325 10.1185 13.8606 11.7832 13.8606 13.5476V13.7691C13.8606 15.1216 13.8606 16.5248 13.8606 17.9563C13.8606 19.4884 13.8606 21.053 13.8606 22.6228C13.8606 24.1641 13.8315 25.7642 13.8606 27.3191C13.8895 28.8627 13.943 30.3156 14.0182 31.6856C14.1092 33.3466 14.2321 34.8856 14.3814 36.3165C14.5867 38.2844 14.8421 40.0477 15.1337 41.642C15.4853 43.5649 15.8896 45.242 16.3224 46.736C16.8925 48.7042 17.5119 50.3545 18.1251 51.8299C19.0947 54.1627 20.0489 56.0581 20.7685 58.0816H63.8611C63.4222 55.993 62.8427 53.9468 62.1995 51.8299C61.7017 50.1917 61.1658 48.5112 60.6274 46.736C60.1398 45.1286 59.6503 43.4436 59.1851 41.642C58.7551 39.9767 58.3459 38.2117 57.9785 36.3165C57.6952 34.8551 57.4366 33.3161 57.2125 31.6856C57.022 30.2992 56.8563 28.8466 56.7214 27.3191C56.5897 25.8277 56.4873 24.265 56.4197 22.6228C56.3717 21.4563 56.3412 20.2496 56.3303 19C56.3273 18.6554 56.3257 18.3075 56.3257 17.9563C56.2935 16.7393 56.3257 15.4997 56.3257 14.2455C56.3257 12.1994 56.3414 10.3145 56.3356 8.53125H13.8606Z"
          fill="white"
        />
        <path
          d="M13.8606 22.6228C13.8606 24.1641 13.8315 25.7642 13.8606 27.3191M13.8606 22.6228C13.8606 21.053 13.8606 19.4884 13.8606 17.9563M13.8606 22.6228H49H56.4197M13.8606 27.3191H56.7214M13.8606 27.3191C13.8895 28.8627 13.943 30.3156 14.0182 31.6856M56.3257 17.9563C56.2935 16.7393 56.3257 15.4997 56.3257 14.2455C56.3257 12.1994 56.3414 10.3145 56.3356 8.53125H13.8606C13.8325 10.1185 13.8606 11.7832 13.8606 13.5476V13.7691C13.8606 15.1216 13.8606 16.5248 13.8606 17.9563M56.3257 17.9563H13.8606M56.3257 17.9563C56.3257 18.3075 56.3273 18.6554 56.3303 19C56.3412 20.2496 56.3717 21.4563 56.4197 22.6228M56.4197 22.6228C56.4873 24.265 56.5897 25.8277 56.7214 27.3191M56.7214 27.3191C56.8563 28.8466 57.022 30.2992 57.2125 31.6856M14.0182 31.6856H57.2125M14.0182 31.6856C14.1092 33.3466 14.2321 34.8856 14.3814 36.3165M57.2125 31.6856C57.4366 33.3161 57.6952 34.8551 57.9785 36.3165M14.3814 36.3165H57.9785M14.3814 36.3165C14.5867 38.2844 14.8421 40.0477 15.1337 41.642M57.9785 36.3165C58.3459 38.2117 58.7551 39.9767 59.1851 41.642M15.1337 41.642H59.1851M15.1337 41.642C15.4853 43.5649 15.8896 45.242 16.3224 46.736M59.1851 41.642C59.6503 43.4436 60.1398 45.1286 60.6274 46.736M16.3224 46.736H60.6274M16.3224 46.736C16.8925 48.7042 17.5119 50.3545 18.1251 51.8299M60.6274 46.736C61.1658 48.5112 61.7017 50.1917 62.1995 51.8299M18.1251 51.8299C19.0947 54.1627 20.0489 56.0581 20.7685 58.0816H63.8611C63.4222 55.993 62.8427 53.9468 62.1995 51.8299M18.1251 51.8299H62.1995"
          stroke="#1D1D1D"
          strokeWidth="0.3"
        />
      </g>
      <path
        d="M58.7639 58.0784C58.325 55.9898 57.7455 53.9436 57.1023 51.8267C56.6045 50.1885 56.0686 48.508 55.5301 46.7328C55.0426 45.1254 54.553 43.4404 54.0879 41.6388C53.6578 39.9735 53.2487 38.2085 52.8813 36.3133C52.5979 34.8519 52.3394 33.3129 52.1153 31.6824C51.9248 30.296 51.7591 28.8434 51.6242 27.3159C51.4924 25.8245 51.39 24.2618 51.3224 22.6196C51.2612 21.1314 51.2285 19.5779 51.2285 17.9531"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path
        d="M53.2092 58.0784C52.7703 55.9898 52.1908 53.9436 51.5476 51.8267C51.0498 50.1885 50.5139 48.508 49.9754 46.7328C49.4879 45.1254 48.9983 43.4404 48.5332 41.6388C48.1032 39.9735 47.694 38.2085 47.3266 36.3133C47.0432 34.8519 46.7847 33.3129 46.5606 31.6824C46.3701 30.296 46.2044 28.8434 46.0695 27.3159C45.9378 25.8245 45.8354 24.2618 45.7678 22.6196C45.7065 21.1314 45.6738 19.5779 45.6738 17.9531"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path
        d="M36.8674 58.0784C36.4285 55.9898 35.849 53.9436 35.2058 51.8267C34.708 50.1885 34.1721 48.508 33.6337 46.7328C33.1461 45.1254 32.6566 43.4404 32.1914 41.6388C31.7614 39.9735 31.3522 38.2085 30.9848 36.3133C30.7014 34.8519 30.4429 33.3129 30.2188 31.6824C30.0283 30.296 29.8626 28.8434 29.7277 27.3159C29.596 25.8245 29.4936 24.2618 29.426 22.6196C29.3647 21.1314 29.332 19.5779 29.332 17.9531"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
    </g>

    {/* Large sparkle, pops in */}
    <g ref={sparkleOneRef}>
      <path
        d="M63.3369 12.582C63.6941 11.806 64.7965 11.8059 65.1533 12.582L68.2236 19.2627L74.9043 22.3379C75.68 22.6953 75.6795 23.7986 74.9033 24.1553L68.2246 27.2236L65.1533 33.9072C64.7964 34.6832 63.6941 34.6832 63.3369 33.9072L60.2588 27.2227L53.582 24.1553C52.8058 23.7985 52.806 22.6951 53.582 22.3379L60.2598 19.2627L63.3369 12.582Z"
        fill="#F9E4B0"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
    </g>

    {/* Small sparkle, pops in */}
    <g ref={sparkleTwoRef}>
      <path
        d="M72.5078 32.582C72.865 31.8062 73.9672 31.8062 74.3242 32.582L75.875 35.9551L79.249 37.5088C80.0249 37.866 80.0248 38.9682 79.249 39.3252L75.875 40.876L74.3242 44.25C73.9674 45.026 72.8652 45.0266 72.5078 44.251L70.9541 40.875L67.582 39.3252C66.8061 38.9683 66.8061 37.866 67.582 37.5088L70.9541 35.9561L72.5078 32.582Z"
        fill="#F9E4B0"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
    </g>
  </svg>
)
